// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"35cd4f87","703":"e48fdc2f","787":"dc8cf084"}[chunkId] + ".chunk.js";
};